import React from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import TermsCheckboxes from '../../../components/TermsCheckboxes/TermsCheckboxes';

const Personal: React.FC = () => (
    <>
      <DynamicForm
        pageName="personal"
        initialValues={ApiLocalStorage.get('user-data')}
      >
        <TermsCheckboxes />
      </DynamicForm>
    </>
  )

export default Personal;
